export default "__VITE_ASSET__BrTo$Iwq__"